import React, { useState } from "react";
import "./DishCalculator.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const DishUI = ({ dishes, quantities, addDish, minusDish, addCustomDish }) => {
  const [customPrice, setCustomPrice] = useState("");

  const handleCustomPriceChange = (e) => {
    const value = e.target.value;
    if (value === "" || Number(value) > 0) {
      setCustomPrice(value);
    }
  };

  const handleConfirmPrice = () => {
    if (!customPrice) return;
    addCustomDish(Number(customPrice));
    setCustomPrice("");
  };

  const isConfirmDisabled =
    !customPrice || dishes.some((d) => d.price === Number(customPrice));

  const totalDishes = quantities.reduce((sum, qty) => sum + (qty || 0), 0);

  return (
    <div className="eachDishCenter">
      <div className="dish-counter-badge">
        {totalDishes} dish{totalDishes !== 1 ? "es" : ""} selected
      </div>
      {dishes.map((dish, index) => {
        const price = dish.price;

        return (
          <div key={dish.id} className={`dish dish${price}`}>
            <Button variant="contained" size="large" onClick={() => minusDish(index)}>
              -{price}
            </Button>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "black",
                  color: "white",
                  padding: "14px 16px",
                  width: "34px",
                  textAlign: "right",
                }}
              >
                <Typography variant="body2">{price}฿</Typography>
              </Box>

              <Box
                sx={{
                  padding: "14px 16px",
                  width: "16px",
                  backgroundColor: "white",
                }}
              >
                <Typography variant="body2">{quantities[index] ?? 0}</Typography>
              </Box>
            </Box>

            <Button variant="contained" size="large" onClick={() => addDish(index)}>
              +{price}
            </Button>
          </div>
        );
      })}

      {/* Custom price */}
      <div class="dish dishCustom">
        <Button
          variant="contained"
          size="large"
          disabled
        >
          -
        </Button>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            overflow: 'hidden',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <Box
              sx={{
                backgroundColor: 'black',
                color: 'white',
                padding: '8px 16px',
                paddingTop: '3px',
                paddingBottom: '7px',
                width: "34px",
                textAlign: "right",
                display: "flex",
                alignItems: "center"
              }}>
              <input
                type="number"
                value={customPrice}
                onChange={handleCustomPriceChange}
                style={{
                  width: '100%',
                  background: 'transparent',
                  border: 'none',
                  color: 'white',
                  textAlign: 'right',
                  padding: 0,
                  margin: 0,
                  fontSize: '0.875rem',
                  fontFamily: 'inherit',
                  outline: 'none'
                }}
                placeholder="฿"
                min="0"
              />
            </Box>
            <Box
              sx={{
                padding: '8px 16px',
                paddingTop: '14px',
                paddingBottom: '14px',
                width: '16px',
                height: '20px',
                backgroundColor: 'white'
              }}>
              <Typography variant="body2">0</Typography>
            </Box>
          </Box>


        </Box>
        <Button
          variant="contained"
          size="large"
          disabled
        >
          +
        </Button>

      </div>
      <div>
        <Button
          variant="contained"
          size="small"
          onClick={handleConfirmPrice}
          disabled={isConfirmDisabled}
        >
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default DishUI;
